export default import.meta.ROLLDOWN_FILE_URL_P3puUs_btQi1Yp3AZFGpMA